import { render } from "./QuemSomos.vue?vue&type=template&id=662ea291"
import script from "./QuemSomos.vue?vue&type=script&lang=js"
export * from "./QuemSomos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__